import utils from '../../../common/utils'
import api from '../../../common/api'

export default {
    methods: {
    /**
     * 获取app列表数据
     */
        getappList() {
            const param = {
                condition: ''
            }
            api.getAppLists(param).then((res) => {
                if (res.resultCode === 0) {
                    this.appList = res.data
                    if (this.appList && this.appList.length > 0) {
                        // 开发用    默认选中“统一资产” 待删
                        // const info = {
                        //     code: 'base-unified-asset',
                        //     id: 6,
                        //     name: '统一资产',
                        //     remark: 'tt',
                        //     type: 'INT'
                        // }

                        const info = this.appList[0]// 默认选中第一个  //待释放
                        this.selectedApp = info
                        this.selectedAppId = info.id
                        this.getRoleListData().then((res1) => {
                            if (res1.length > 0) {
                                const obj = res1[0]
                                this.selectedRole = obj
                                this.selectedRole.selected = true // 选中第一项
                            }
                            this.getRoleUserCount()
                            this.getAuthorityList()
                        })
                    }
                }
            })
        },
        /**
     * 获取角色列表
     * @returns Promise roleList
     */
        getRoleListData() {
            return new Promise((resolve, reject) => {
                api
                    .getRoleList({
                        applicationId: this.selectedAppId,
                        condition: this.roleFilterStr || '',
                        pageNum: 0,
                        pageSize: 99999999
                    })
                    .then((res) => {
                        this.roleList = []
                        if (res.resultCode === 0 && res.data?.data.length !== 0) {
                            this.roleList = utils.arrayToTree(
                                res.data.data,
                                {
                                    key: 'id',
                                    parentKey: 'parentId'
                                },
                                { dropDownVisible: false }
                            )
                            resolve(this.roleList)
                        } else {
                            resolve([])
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        /**
     * 添加角色
     */
        addRoleData() {
            const param = {
                applicationId: this.selectedAppId,
                roleName: this.formValidate.roleName,
                remark: this.formValidate.remark
            }
            api.addRole(param).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('添加成功!')
                    this.handleReset('formValidate')
                    this.getRoleListData().then((res1) => {
                        let arr = []
                        // 定位选中的角色
                        if (this.selectedRole.id) {
                            arr = res1.map((val) => {
                                if (val.id === this.selectedRole.id) {
                                    val.selected = true
                                    this.selectedRole = val
                                }
                                return val
                            })
                        } else {
                            // 默认选中第一项
                            const obj = res1[0]
                            this.selectedRole = obj
                            this.selectedRole.selected = true // 选中第一项
                            arr = res1
                        }
                        this.roleList = arr
                    })
                    this.roleModal = false
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        /**
     * 编辑角色
     */
        roleUpdate() {
            const param = {
                applicationId: this.selectedAppId,
                id: this.selectedRole.id,
                roleName: this.formValidate.roleName,
                remark: this.formValidate.remark
            }
            api.updateRole(param).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('编辑成功！')
                    this.handleReset('formValidate')
                    this.getRoleListData().then((res1) => {
                        // 定位选中的角色
                        const arr = res1.map((val) => {
                            if (val.id === this.selectedRole.id) {
                                val.selected = true
                                this.selectedRole = val
                            }
                            return val
                        })
                        this.roleList = arr
                    })
                    this.roleModal = false
                } else {
                    this.$Message.error(res.resultMessage)
                }
            })
        },
        /**
     * 获取用户数
     */
        getRoleUserCount() {
            const param = {
                roleId: this.selectedRole.id === undefined ? 0 : this.selectedRole.id
            }
            api.getRoleUserCount(param).then((res) => {
                if (res.resultCode === 0) {
                    this.roleUserCount = res.data
                }
            })
        },
        /**
     * 获取用户列表
     */
        getUserList() {
            api
                .getRoleMemberList({
                    roleId: this.selectedRole?.id,
                    pageIndex: this.memberList.curPage,
                    pageSize: this.memberList.pageSize
                })
                .then((res) => {
                    Object.assign(this.memberList, {
                        data: res.data,
                        curPage: res.data.pageIndex,
                        pageSize: res.data.pageSize,
                        total: res.data.recordTotal
                    })
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        /**
     * 获取角色对应的权限列表数据
     */
        getAuthorityList() {
            const key = this.selectedApp?.code
            api.getAuthority(key).then((res) => {
                if (res.resultCode === 0) {
                    this.authorityListData = res.data === null ? [] : res.data
                    // 没有权限项时，默认加一个""系统操作权限"
                    if (this.authorityListData.length === 0) {
                        this.authorityListData = []
                        this.authorityListData.push({
                            category: 'YHZYZL',
                            dataName: '系统操作权限',
                            dataValue: 'SYSTEM_MENU',
                            id: '556',
                            level: '',
                            pcode: ''
                        })
                    }
                    this.getAuthoritySelectData()
                    // this.getTree()
                }
            })
        },
        /**
     * 根据条件查询菜单树
     * @returns Promise对象
     */
        getTree() {
            const authorityCategory = this.authorityListData.length === 0
                ? 'SYSTEM_MENU'
                : this.authorityListData[this.menuItemIndex].dataValue
            return new Promise((resolve, reject) => {
                api
                    .getTreeData({
                        appId: this.selectedAppId ? this.selectedAppId : '',
                        authorityCategory:
              this.authorityListData.length === 0
                  ? 'SYSTEM_MENU'
                  : authorityCategory
                        // roleId: this.selectedRole.id ? this.selectedRole.id : ''
                    })
                    .then((res) => {
                        if (res.resultCode === 0 && res.data) {
                            // this.singTypeInitData = res.data.map((val) => {
                            //     if (val.node) {
                            //         val.children = val.node
                            //     }
                            //     return val
                            // })

                            const resData = res.data;
                            if (authorityCategory === 'SYSTEM_MENU') {
                                const ids = (this.selectData?.systemMenu || []).map((item) => item.id);
                                utils.treeForeach(resData, 'node', (item) => {
                                    if (item.node) {
                                        item.children = item.node
                                    }
                                    if (ids.includes(item.id)) {
                                        item.selected = false
                                        item.checked = true
                                    } else {
                                        item.selected = false
                                        item.checked = false
                                    }
                                })
                            }
                            this.singTypeInitData = resData
                            this.$set(
                                this.initDataObj,
                                authorityCategory,
                                this.singTypeInitData
                            )

                            this.initDataObjCopy = JSON.parse(
                                JSON.stringify(this.initDataObj)
                            )
                            resolve(this.initDataObj)
                        } else {
                            resolve([])
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        /**
     * 获取角色下某个权限分类的勾选信息(前台传角色id)
     */
        getAuthoritySelectData() {
            const params = `roleId=${
                this.selectedRole.id ? this.selectedRole.id : ''
            }` // 'roleId=416'
            api.getAuthoritySelectData(params).then((res) => {
                if (res.resultCode === 0) {
                    this.selectData = res.data
                }
            })
        },
        /**
     * 提交编辑的权限信息
     * @param {Object} param {newMenuIdList,oldMenuIdList,roleId}
     */
        updateAuthorityInfo(param) {
            api.updateAuthority(param).then((res) => {
                if (res.resultCode === 0) {
                    this.$Message.success('编辑成功！')
                    // 更新选中的数据
                    this.getAuthoritySelectData()
                }
            })
        },
        // // 根据库查表
        // getTablesByDBInfo() {
        //     const param = {
        //         parentMenuId: 6091 // 6091  主题库(Impala)
        //     }
        //     api.getTablesByDB(param).then((res) => {
        //         if (res.resultCode === 0) {
        //             console.log('根据库查表', res)
        //             this.tableListAll = res.data
        //             this.tableList = this.tableListAll.slice(0, 50)
        //             this.tableListMore = this.tableList
        //         }
        //     })
        // },

        // 1查库数据  2根据库查表
        getTablesByDBInfo(parentId) {
            const param = {
                appId: this.selectedAppId,
                authorityCategory: this.curItemObj.dataValue,
                parentId // 6091  主题库(Impala)
            }
            return new Promise((resolve, reject) => {
                api
                    .getTablesByDB(param)
                    .then((res) => {
                        if (res.resultCode === 0) {
                            console.log('根据库查表', res)
                            // let obj = {
                            //   dbList: [],
                            //   tableList: [],
                            //   tableListAll:[]
                            // }
                            if (parentId === 0) {
                                this.dbList = res.data
                            // this.checkedDBVal = 7191 // 默认选中的库  原始库(Mysql)
                            // this.getTablesByDBInfo(
                            //     this.checkedDBVal
                            // )
                            } else {
                                this.tableList = res.data
                                this.tableListAll = res.data
                            }
                            resolve()
                        } else {
                            resolve([])
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    }
}
